export default __webpack_public_path__ + "static/media/success-image.8a60b167.svg";